import React, { useEffect, useRef, useState } from 'react';
import { Typography } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const safeDocumentUrl = value => {
  try { const url = new URL(value); return url.protocol === 'https:' ? url.href : null; } catch { return null; }
};

export default function ReportAttachment({ document, attachmentKey, onStatus }) {
  const [pages, setPages] = useState(0);
  const [failed, setFailed] = useState(false);
  const rendered = useRef(new Set());
  const url = safeDocumentUrl(document.url);
  const name = document.name || document.file_name || `Document ${document.id}`;
  const mime = document.mime_type || document.content_type || '';
  const isPdf = mime === 'application/pdf' || /\.pdf$/i.test(name);
  const isImage = mime.startsWith('image/') || /\.(png|jpe?g|webp)$/i.test(name);
  useEffect(() => {
    onStatus(attachmentKey, !url ? 'error' : isPdf || isImage ? 'loading' : 'ready');
  }, [attachmentKey, onStatus, url, isPdf, isImage]);
  const fail = () => { setFailed(true); onStatus(attachmentKey, 'error'); };
  return <section className="report-attachment">
    <Typography variant="subtitle2" fontSize="20px">Document Name: {name}</Typography>
    {!url ? <p>File content is unavailable in this export.</p> : <>
      {failed && <p>File preview could not be loaded. Use the document link while it is valid.</p>}
      {isPdf && !failed && <Document file={url} loading={<p>Loading document…</p>}
        onLoadSuccess={({ numPages }) => setPages(numPages)} onLoadError={fail}>
        {Array.from({ length: pages }, (_, index) => <Page key={index} pageNumber={index + 1} width={595}
          renderAnnotationLayer={false} renderTextLayer={false} onRenderError={fail} onRenderSuccess={() => {
            rendered.current.add(index);
            if (rendered.current.size === pages) onStatus(attachmentKey, 'ready');
          }} />)}
      </Document>}
      {isImage && !failed && <img src={url} alt={name} onLoad={() => onStatus(attachmentKey, 'ready')} onError={fail} style={{ maxWidth: '100%' }} />}
      {!isImage && !isPdf && <p>This file type is included as a link; its contents are not embedded in the PDF.</p>}
      <a href={url} target="_blank" rel="noopener noreferrer">Open {name}</a>
    </>}
  </section>;
}

